import React from 'react'
import { Button, Modal, Typography } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import ComponentTitle from '@/pages/safety-equipment/widgets/component-title'
import { useGetSampleFile } from '../../../utils'
import { Message } from '@/components'

const { Text } = Typography

interface PropsType {
  visible: boolean
  resourceId: string
  sha256: string
  onClose: () => void
}

const DownloadModal: React.FC<PropsType> = ({ visible, resourceId, sha256, onClose }) => {
  // 样本文件下载
  const [getSampleFile, getSampleFileLoading] = useGetSampleFile()

  const handleDownload = async () => {
    try {
      console.log('开始下载，参数：', { resourceId, sha256 })
      const response = await getSampleFile({ resourceId, sha256 })
      console.log('下载响应：', response)

      // 从响应中获取blob数据
      const blob = response.data
      console.log('Blob数据：', blob)

      // 创建下载链接
      const url = window.URL.createObjectURL(blob)
      console.log('创建的URL：', url)

      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = `sample_${sha256}.zip` // 可以根据需要修改文件名
      console.log('准备下载文件：', a.download)

      document.body.appendChild(a)
      a.click()
      console.log('点击下载链接')

      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      Message.success(t('下载成功'))
      onClose()
    } catch (error) {
      console.error('下载失败：', error)
      Message.error(t('下载失败'))
    }
  }

  return (
    <Wrapper
      title={<ComponentTitle title={t('下载确认')} />}
      zIndex={1001}
      open={visible}
      onCancel={onClose}
      footer={
        <div>
          <Button onClick={onClose} className="cancel-btn">
            {t('取消')}
          </Button>
          <Button type="primary" onClick={handleDownload} loading={getSampleFileLoading}>
            {t('确认下载')}
          </Button>
        </div>
      }
      centered
    >
      <div className="modal-content">
        <span className="warning-icon">!</span>
        <span className="warning-text">
          {t('请输入')}
          <Text strong copyable>
            BAS0857
          </Text>
          {t('进行.zip文件解压，文件解压后会对系统造成一定影响，请谨慎运行。')}
        </span>
      </div>
    </Wrapper>
  )
}

export default DownloadModal

const Wrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
      padding: 19px 20px;
    }

    .ant-modal-body {
      padding: 24px;

      .modal-content {
        display: flex;
        align-items: center;
        gap: 12px;

        .warning-icon {
          width: 20px;
          height: 20px;
          background: #ffb800;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
        }

        .warning-text {
          color: #1d2129;
          font-size: 14px;
          line-height: 20px;

          .ant-typography {
            color: #4238c9;
          }
        }
      }
    }

    .ant-modal-footer {
      border-top: none;
      padding: 0 24px 16px;

      .ant-btn {
        height: 32px;
        padding: 0 16px;
        border-radius: 6px;

        &.cancel-btn {
          color: #666;
          border-color: #999;
          margin-right: 10px;
        }

        &.ant-btn-primary {
          background: linear-gradient(270deg, #4238c9 100%, #4238c9 100%);
          border-color: #4238c9;

          &:hover {
            background: linear-gradient(270deg, #4238c9 0%, #6c65d4 100%);
            border-color: #6c65d4;
          }
        }
      }
    }
  }
`
